import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../../../configs/translations'
import { setCockpitFilterManager } from '../../../../../../model'
import {
  selectCockpitFilterManager,
  selectCockpitManagerUsers,
} from '../../../../../../model/selectors'
import { CockpitUserSelect } from '../../../../../cockpitUserSelect/CockpitUserSelect'
import { CockpitFilterLabel } from '../../../cockpitFilterLabel/CockpitFilterLabel'

import styles from './CockpitManagerField.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.manager

export const CockpitManagerField = ({ hideLabel = false }: { hideLabel?: boolean }) => {
  const dispatch = useAppDispatch()
  const selectedManager = useSelector(selectCockpitFilterManager)
  const managerUsers = useSelector(selectCockpitManagerUsers)

  const handleChange = useCallback(
    (emails: string[]) => {
      dispatch(setCockpitFilterManager(emails))
    },
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <CockpitFilterLabel text={KEYS.label} placeholderOnly={hideLabel} />
      <CockpitUserSelect
        value={selectedManager}
        onChange={handleChange}
        users={managerUsers}
        placeholderKey={hideLabel ? KEYS.label : KEYS.all}
        sortByName
      />
    </div>
  )
}
